// Firebase configuration
// To set up Firebase authentication:
// 1. Go to https://console.firebase.google.com/
// 2. Create a new project
// 3. Enable Google authentication in Authentication > Sign-in method
// 4. Add your app and copy the config below

import firebase from "firebase/compat/app";
import "firebase/compat/auth";

// Replace these values with your Firebase project configuration
// Get these from: Project Settings > General > Your apps
const firebaseConfig = {
    apiKey: "AIzaSyDunp4x52a4wyVZkjhTJFK67LgxLwcBPUs",
    authDomain: "goonmeetings.firebaseapp.com",
    projectId: "goonmeetings",
    storageBucket: "goonmeetings.firebasestorage.app",
    messagingSenderId: "151528364901",
    appId: "1:151528364901:web:04216ef0a80fc72b80df8c"
};

// Detect if running in WebView (mobile app embedded browser)
const isWebView = (() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isAndroid = userAgent.match(/wv|WebView|android/i);
    const isIOS = userAgent.match(/WebKit/i) && userAgent.match(/Mobile/i);
    const isInstagram = userAgent.match(/Instagram/i);
    const isFacebook = userAgent.match(/FBAN/i) || userAgent.match(/FBAV/i);
    return !!(isAndroid || isIOS || isInstagram || isFacebook);
})();

console.log('[Firebase Auth] Running in WebView:', isWebView);

// Initialize Firebase
if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
}

const auth = firebase.auth();

// DEBUG: Check storage availability and log diagnostic info
console.log('[Firebase Auth] Initializing auth module...');
console.log('[Firebase Auth] sessionStorage available:', typeof sessionStorage !== 'undefined');
console.log('[Firebase Auth] localStorage available:', typeof localStorage !== 'undefined');

// Check if sessionStorage is accessible
try {
    const testKey = '__firebase_auth_test__';
    sessionStorage.setItem(testKey, 'test');
    sessionStorage.removeItem(testKey);
    console.log('[Firebase Auth] sessionStorage is accessible: true');
} catch (e) {
    console.error('[Firebase Auth] sessionStorage is NOT accessible:', e.message);
}

// Set auth persistence to SESSION (more reliable in partitioned environments)
// For WebView, also try NONE to avoid storage issues
const persistenceType = isWebView
    ? firebase.auth.Auth.Persistence.NONE
    : firebase.auth.Auth.Persistence.SESSION;

console.log('[Firebase Auth] Setting persistence to:', isWebView ? 'NONE (WebView detected)' : 'SESSION');

auth.setPersistence(persistenceType)
    .then(() => {
        console.log('[Firebase Auth] Persistence set successfully');
    })
    .catch((error) => {
        console.error('[Firebase Auth] Error setting persistence:', error.code, error.message);
    });

// Listen for auth state changes and log debug info
auth.onAuthStateChanged((user) => {
    if (user) {
        console.log('[Firebase Auth] User authenticated:', user.uid, user.email);
    } else {
        console.log('[Firebase Auth] No user authenticated (null)');
    }
}, (error) => {
    console.error('[Firebase Auth] Auth state listener error:', error.code, error.message);
});

const googleProvider = new firebase.auth.GoogleAuthProvider();

// Force popup mode and prevent redirect
googleProvider.setCustomParameters({
    prompt: 'select_account'
});

// Sign in with Google - Always use popup, never redirect
export const signInWithGoogle = () => {
    // For WebView environments, use a different approach
    if (isWebView) {
        console.log('[Firebase Auth] Using WebView authentication flow');
        // In WebView, we need to handle auth differently
        return auth.signInWithRedirect(googleProvider)
            .then(() => {
                // This will trigger a redirect in WebView
                console.log('[Firebase Auth] Redirect initiated for WebView');
            })
            .catch((error) => {
                console.error("Error signing in with Google (WebView):", error);
                throw error;
            });
    }

    // For regular browsers, always use popup
    console.log('[Firebase Auth] Using popup authentication flow');
    return auth.signInWithPopup(googleProvider)
        .then((result) => {
            const user = result.user;
            return {
                uid: user.uid,
                displayName: user.displayName,
                email: user.email,
                photoURL: user.photoURL
            };
        })
        .catch((error) => {
            // If popup is blocked, try redirect as fallback
            if (error.code === 'auth/popup-blocked' || error.code === 'auth/cancelled-popup-request') {
                console.warn('[Firebase Auth] Popup blocked, falling back to redirect');
                return auth.signInWithRedirect(googleProvider)
                    .then(() => {
                        // User will be redirected, need to handle on return
                        console.log('[Firebase Auth] Redirect fallback initiated');
                        return null;
                    });
            }
            console.error("Error signing in with Google:", error);
            throw error;
        });
};

// Sign out
export const logOut = () => {
    return auth.signOut()
        .then(() => {
            console.log("User signed out successfully");
        })
        .catch((error) => {
            console.error("Error signing out:", error);
            throw error;
        });
};

// Handle redirect result (needed for WebView or fallback scenarios)
export const getAuthResult = () => {
    return auth.getRedirectResult()
        .then((result) => {
            if (result && result.user) {
                const user = result.user;
                console.log('[Firebase Auth] Redirect auth result:', user.uid);
                return {
                    uid: user.uid,
                    displayName: user.displayName,
                    email: user.email,
                    photoURL: user.photoURL
                };
            }
            return null;
        })
        .catch((error) => {
            console.error("Error getting redirect result:", error);
            // Handle the specific "missing initial state" error
            if (error.code === 'auth/internal-error' &&
                error.message && error.message.includes('missing initial state')) {
                console.error('[Firebase Auth] WebView storage issue detected');
            }
            throw error;
        });
};

// Auth state listener
export const authStateListener = (callback) => {
    return auth.onAuthStateChanged((user) => {
        if (user) {
            callback({
                uid: user.uid,
                displayName: user.displayName,
                email: user.email,
                photoURL: user.photoURL
            });
        } else {
            callback(null);
        }
    });
};

export default firebase;
